import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomPipesModule } from '@shared/pipes/custom-pipes.module';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxSelectModule } from 'ngx-select-ex';
import { SharedModule } from '../../shared/shared.module';
import { Error404Component } from './error404/error404.component';
import { Error500Component } from './error500/error500.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import LoginCallbackComponent from './login-callback/login-callback.component';
import SupportLoginCallbackComponent from './support-login-callback/support-login-callback.component';
import SupportExpiredComponent from './support-expired/support-expired.component';
import { SupportLoginComponent } from './support-login/support-login.component';
import LoginBackDoorComponent from './login-backdoor/login-backdoor.component';

/* Use this routes definition in case you want to make them lazy-loaded */
const routes: Routes = [
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },
    { path: 'login-callback', component: LoginCallbackComponent },
    { path: 'login-backdoor', component: LoginBackDoorComponent },
    { path: 'support-expired', component: SupportExpiredComponent },
    { path: 'support-login-callback', component: SupportLoginCallbackComponent },
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        NgxLoadingModule,
        CustomPipesModule,
        NgxSelectModule
    ],
    declarations: [
        MaintenanceComponent,
        Error404Component,
        Error500Component,
        LoginCallbackComponent,
        SupportLoginCallbackComponent,
        SupportExpiredComponent,
        SupportLoginComponent
    ],
    exports: [
        RouterModule,
        MaintenanceComponent,
        Error404Component,
        Error500Component,
        LoginCallbackComponent,
        SupportLoginCallbackComponent,
        SupportExpiredComponent,
        SupportLoginComponent
    ]
})
export class PagesModule { }
